import { Navigate, Route, Routes } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Home from "./page/Home";
import AboutUs from "./page/AboutUs";
import PrivacyPollicy from "./page/PrivacyPollicy";
import Gift from "./page/Gift";
import LayoutMain from "./componets";
import SupportForm from "./page/SupportForm";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { setWebsiteLoginData } from "./redux/slice/userSlice";
import Error404 from "./componets/Error404";
import Error500 from "./componets/Error500";
import Loader from "./componets/Loader";
import axios from "axios";

function App() {
  const { websiteLoginData } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // Fetch existing data from API on page load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.55clubregister.com/api/v1/I4gsv24w1/rest_api/get_setting.php"
        );

        if (response.data && response.data.status === "1") {
          dispatch(setWebsiteLoginData(response.data.data))
        } else {
          toast.error(response.data.message || "Failed to fetch data.");
        }
      } catch (error) {
        toast.error("Error fetching website data. Please try again.");
        console.error("Fetch error:", error);
      } finally {
      }
    };

    fetchData();
  }, []);

  if (!websiteLoginData) return <Loader />;
  return (
    <>
      <Routes>
        <Route element={<Error404 />} path={`/404`} />
        <Route element={<Error500 />} path={`/500`} />
        <Route path='*' element={<Navigate to={`/404`} />} />

        <Route element={<LayoutMain />}>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/help" element={<SupportForm />} />
          <Route path="/privacypolicy" element={<PrivacyPollicy />} />
          <Route path="/gift" element={<Gift />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
